import type { SxProps, Theme } from "@mui/material/styles";

export const main: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  width: "100%",
  bgcolor: "background.default",
  boxSizing: "border-box",
};

export const content =
  (maxWidth: number): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    px: { xs: 2, sm: 4 },
    py: { xs: 2, sm: 4 },
    width: "100%",
    maxWidth,
    mx: "auto",
    boxSizing: "border-box",
  });
